/**
 * @generated SignedSource<<8577ffc1f77a7e6d901309e248abbaaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OccurrenceNameAndTimeFragment$data = {
  readonly datetimeRange: ReadonlyArray<string>;
  readonly event: {
    readonly isRecurring: boolean;
  };
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentType": "OccurrenceNameAndTimeFragment";
};
export type OccurrenceNameAndTimeFragment$key = {
  readonly " $data"?: OccurrenceNameAndTimeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OccurrenceNameAndTimeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OccurrenceNameAndTimeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "datetimeRange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isRecurring",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Occurrence",
  "abstractKey": null
};

(node as any).hash = "50f409c29e8434bc21cbeea38eb9e8e0";

export default node;
